import { render } from "./defaultDownloadInstructions.vue?vue&type=template&id=63a02949&ts=true"
import script from "./defaultDownloadInstructions.vue?vue&type=script&lang=ts"
export * from "./defaultDownloadInstructions.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__